import { Feature } from 'config/feature-flags';
import { Directive, inject, Input, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagService } from '@shared/services/feature-flag.service';

@Directive({ selector: '[featureFlag]' })
export class FeatureFlagDirective {
  constructor(private featureFlagService: FeatureFlagService) {}
  templateRef = inject(TemplateRef);
  viewContainer = inject(ViewContainerRef);
  hasView = signal(false);

  @Input() set featureFlag(feature: Feature) {
    if (this.featureFlagService.featureEnabled(feature) && !this.hasView()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView.set(true);
    } else {
      this.viewContainer.clear();
      this.hasView.set(false);
    }
  }

  @Input() set featureFlagElse(elseTemplateRef: TemplateRef<any>) {
    if (!this.hasView()) {
      this.viewContainer.createEmbeddedView(elseTemplateRef);
    }
  }
}

@Directive({ selector: '[notFeatureFlag]' })
export class NotFeatureFlagDirective {
  constructor(private featureFlagService: FeatureFlagService) {}
  templateRef = inject(TemplateRef);
  viewContainer = inject(ViewContainerRef);
  hasView = signal(false);

  @Input() set notFeatureFlag(feature: Feature) {
    if (!this.featureFlagService.featureEnabled(feature) && !this.hasView()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView.set(true);
    } else {
      this.viewContainer.clear();
      this.hasView.set(false);
    }
  }
}
